const fieldLayoutRow = `
    .mfield-row {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export {
    fieldLayoutRow
};